export default function PaintTypesElPaso() {
  const paintTypes = [
    {
      name: 'Acrylic Latex Paint',
      description: 'Durable, easy to clean, and perfect for El Paso\'s dry climate. Ideal for interior walls and ceilings.',
      bestFor: 'Interior walls, living rooms, bedrooms',
      image: 'https://public.readdy.ai/ai/img_res/eb50f3041cbd8fbb266da954d40c076f.jpg'
    },
    {
      name: 'Elastomeric Paint',
      description: 'Flexible coating that expands and contracts with temperature changes, perfect for El Paso\'s extreme weather.',
      bestFor: 'Exterior stucco, concrete walls',
      image: 'https://readdy.ai/api/search-image?query=Elastomeric%20paint%20application%20on%20exterior%20stucco%20wall%2C%20thick%20flexible%20coating%20being%20applied%20with%20professional%20equipment%2C%20southwestern%20style%20home%20exterior%20with%20textured%20surface%2C%20weather%20resistant%20paint%20protecting%20building%20from%20harsh%20climate%20conditions%20with%20superior%20coverage&width=600&height=400&seq=paint-type-002&orientation=landscape'
    },
    {
      name: 'Semi-Gloss & Gloss',
      description: 'Moisture-resistant and easy to clean, ideal for high-traffic areas and rooms with humidity.',
      bestFor: 'Kitchens, bathrooms, trim, doors',
      image: 'https://readdy.ai/api/search-image?query=Glossy%20semi-gloss%20paint%20finish%20on%20kitchen%20cabinets%20and%20trim%2C%20shiny%20reflective%20surface%20showing%20durability%20and%20easy%20cleaning%20properties%2C%20modern%20kitchen%20interior%20with%20white%20painted%20cabinetry%2C%20professional%20quality%20paint%20application%20with%20smooth%20lustrous%20finish%20highlighting%20craftsmanship&width=600&height=400&seq=paint-type-003&orientation=landscape'
    },
    {
      name: 'Flat & Matte Paint',
      description: 'Non-reflective finish that hides imperfections, perfect for ceilings and low-traffic areas.',
      bestFor: 'Ceilings, adult bedrooms, formal spaces',
      image: 'https://readdy.ai/api/search-image?query=Matte%20flat%20paint%20finish%20on%20interior%20walls%20showing%20smooth%20non-reflective%20surface%2C%20elegant%20bedroom%20with%20sophisticated%20flat%20paint%20creating%20calm%20atmosphere%2C%20professional%20painting%20demonstrating%20flawless%20coverage%20hiding%20wall%20imperfections%2C%20soft%20neutral%20color%20palette%20with%20velvety%20texture%20finish&width=600&height=400&seq=paint-type-004&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Paint Types for El Paso Homes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose the right paint type for your project based on El Paso's unique climate and your specific needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {paintTypes.map((type, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="h-64 w-full overflow-hidden">
                <img
                  src={type.image}
                  alt={type.name}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {type.name}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {type.description}
                </p>
                <div className="flex items-start gap-2 bg-teal-50 p-4 rounded-lg">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-0.5"></i>
                  <div>
                    <strong className="text-gray-900 text-sm">Best For:</strong>
                    <p className="text-gray-700 text-sm">{type.bestFor}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
